module.exports = __webpack_public_path__ + "img/back_left.e2775765.svg";